<template>
    <div>
        <button class="bg-tc-blue-1 rounded-full text-white text-20 px-4 py-1 w-full sm:w-281px h-11"
            :class="{'opacity-30': isBtnDisable}">
            <slot></slot>
        </button>
    </div>
</template>

<script>
export default {
    name: 'Submitbtn',
    props: {
        isBtnDisable:{
            type: Boolean,
            default: false
        }
    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>

</style>
